<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="error" class="alert_success" v-if="alert_show_remain_lostqty === true">ยอดคงเหลือและสูญเสียรวมกันไม่ควรเกินยอดเบิก</v-alert>
        <v-alert type="error" class="alert_success" v-if="alert_show_not_summarize === true">ไม่มีวัตถุดิบที่ต้องการจะเบิก</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <v-card>
            <div class="pa-3">
                <v-row>
                    <v-col cols="12">
                        <h3>สรุปรายการโซน</h3>
                        <div class="d-flex justify-space-between">
                            <div>เบิกโซน {{ zone.name }}</div>
                            <div>วันที่ {{ new Date().getDate() +' '+ $store.state.monthList[new Date().getMonth()].name +' '+ `${new Date().getFullYear() + 543}`}}</div>
                        </div>
                        <div class="mt-2">
                            <v-form ref="form_add" @submit.prevent="summarizeZoneUpdate()">
                                <v-simple-table>
                                    <thead>
                                        <tr>
                                            <th rowspan="2" class="text-center border_header_add_lotout_summarize_list">
                                                รายการ
                                            </th>
                                            <th rowspan="2" class="text-center border_header_add_lotout_summarize_list">
                                                ราคาต้นทุน
                                            </th>
                                            <th rowspan="2" class="text-center border_header_add_lotout_summarize_list">
                                                ยอดเบิก
                                            </th>
                                            <th rowspan="2" class="text-center border_header_add_lotout_summarize_list">
                                                คงเหลือ
                                            </th>
                                            <th rowspan="2" class="text-center border_header_add_lotout_summarize_list">
                                                สูญเสีย
                                            </th>
                                            <th rowspan="2" class="text-center border_header_add_lotout_summarize_list">
                                                ใช้
                                            </th>
                                            <th colspan="2" class="text-center border_header_add_lotout_summarize_list">
                                                มูลค่ารวม (บาท)
                                            </th>
                                        </tr>
                                        <tr>
                                            <th class="text-center border_header_add_lotout_summarize_list">
                                                ใช้
                                            </th>
                                            <th class="text-center border_header_add_lotout_summarize_list">
                                                สูญเสีย
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(out_zone_detail,index) in out_zone" :key="index">
                                            <td class="text-center border_header_add_lotout_summarize_list" width="30%">{{ out_zone_detail.mat_name }}</td>
                                            <td class="text-center border_header_add_lotout_summarize_list">
                                                {{ out_zone_detail.mat_price }}
                                            </td>
                                            <td class="text-center border_header_add_lotout_summarize_list">
                                                {{ currencyFormat(out_zone_detail.quantity) }}
                                            </td>
                                            <td class="text-center border_header_add_lotout_summarize_list pt-2 pb-2" width="10%">
                                                <div v-if="out_zone_detail.quantity != 0">
                                                    <v-text-field type="number" @keypress="isNumberPrice($event)" onpaste="return false" @input="useAll(out_zone_detail.lot_detail_id)" v-model="out_zone_detail.remain" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกคงเหลือ']" required dense outlined></v-text-field>
                                                </div>
                                                <div v-if="out_zone_detail.quantity == 0">
                                                    <v-text-field type="number" @keypress="isNumberPrice($event)" onpaste="return false" v-model="out_zone_detail.remain" hide-details="auto" disabled dense outlined></v-text-field>
                                                </div>
                                            </td>
                                            <td class="text-center border_header_add_lotout_summarize_list pt-2 pb-2" width="10%">
                                                <div v-if="out_zone_detail.quantity != 0">
                                                    <v-text-field type="number" @keypress="isNumberPrice($event)" onpaste="return false" @input="useAll(out_zone_detail.lot_detail_id)" v-model="out_zone_detail.lose" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกสูญเสีย']" required dense outlined></v-text-field>
                                                </div>
                                                <div v-if="out_zone_detail.quantity == 0">
                                                    <v-text-field type="number" @keypress="isNumberPrice($event)" onpaste="return false" v-model="out_zone_detail.lose" hide-details="auto" disabled dense outlined></v-text-field>
                                                </div>
                                            </td>
                                            <td class="text-center border_header_add_lotout_summarize_list">
                                                {{ parseFloat(out_zone_detail.use_all).toFixed(2) }}
                                            </td>
                                            <td class="text-center border_header_add_lotout_summarize_list">
                                                {{ parseFloat(out_zone_detail.use_all * out_zone_detail.mat_price).toFixed(2) }}
                                            </td>
                                            <td class="text-center border_header_add_lotout_summarize_list">
                                                {{ out_zone_detail.lose ? parseFloat(out_zone_detail.mat_price * out_zone_detail.lose).toFixed(2) : parseFloat(0).toFixed(2) }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-center border_header_add_lotout_summarize_list pt-2 pb-2" colspan="8">
                                                <div class="error--text" v-if="amount_all > 0 && text_erroramount_all === false">** ยอดคงเหลือและสูญเสียรวมกันไม่ควรเกินยอดเบิก **</div>
                                                <v-btn color="#28ab28" type="submit" class="white--text" width="20%" height="50" :disabled="amount_all == 0 ? false : true">
                                                    บันทึก
                                                </v-btn>
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-form>
                        </div>
                    </v-col>
                </v-row>
            </div>
            <v-dialog v-model="open_alert_show_add" persistent max-width="600">
                <v-card>
                    <v-card-title>
                        สำเร็จ
                    </v-card-title>

                    <v-card-text>
                        สรุปรายการโซน{{ zone.name }}เรียบร้อย
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" text @click="confirmSuccess()">
                            ตกลง
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="page_not_found" persistent max-width="600">
                <v-card>
                    <v-card-title>
                        คำเตือน
                    </v-card-title>

                    <v-card-text>
                        ไม่มีวัตถุดิบที่ใช้ในการเบิกโซน {{ zone.name }}
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" text @click="$router.push('/addlotout')">
                            ตกลง
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>
    </div>
</div>
</template>

<script>
import zoneall from '@/api/stock/stocklist/zoneall.js'
import {
    currencyFormat
} from '@/helper/numberformat.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            page_not_found: false,
            open_alert_show_add: false,
            alert_show_remain_lostqty: false,
            alert_show_not_summarize: false,
            zone: null,
            out_zone: [],
        }
    },
    methods: {
        currencyFormat,
        async isNumberPrice(evt) {
            evt = (evt) ? evt : window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        async zoneDetail() {
            this.loading_page = true
            this.page_not_found = false
            await zoneall.zoneList().then((response) => {
                if (response.data.successful === true) {
                    this.zone = response.data.zone.find((detail) => {
                        return detail.id == this.$store.state.addLotinId
                    })
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
            await zoneall.summarizeZoneList(this.zone.id).then((response) => {
                if (response.data.successful === true) {

                    response.data.list.forEach((detail) => {
                        this.out_zone.push({
                            lot_detail_id: detail.lot_detail_id,
                            mat_id: detail.mat_id,
                            mat_name: detail.mat_name,
                            mat_price: detail.mat_price,
                            quantity: detail.quantity,
                            remain: '0',
                            lose: '0',
                            use_all: detail.quantity,
                        })
                    })
                    this.loading_page = false
                }
                if (response.data.successful === false) {
                    this.page_not_found = true
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async useAll(lot_detail_id) {
            let out_zone_all = this.out_zone.find((detail) => {
                return detail.lot_detail_id == lot_detail_id
            })
            out_zone_all.use_all = out_zone_all.quantity
            out_zone_all.use_all -= out_zone_all.remain
            out_zone_all.use_all -= out_zone_all.lose
        },
        async summarizeZoneUpdate() {
            if (this.out_zone.length <= 0) {
                this.alert_show_not_summarize = true
                setTimeout(() => this.alert_show_not_summarize = false, 5000)
            }
            if (this.out_zone.length > 0) {
                if (this.$refs.form_add.validate()) {
                    let checkAll = false
                    this.out_zone.forEach((detail) => {
                        let all_remain_lostqty = parseFloat(detail.remain) + parseFloat(detail.lose)
                        if (all_remain_lostqty > detail.quantity) {
                            checkAll = true
                        }
                    })
                    if (checkAll === true) {
                        this.alert_show_remain_lostqty = true
                        setTimeout(() => this.alert_show_remain_lostqty = false, 5000)
                    } else {
                        this.loading_page = true

                        const mat_id = this.out_zone.map((detail) => {
                            return detail.mat_id
                        })

                        const lot_detail_id = this.out_zone.map((detail) => {
                            return detail.lot_detail_id
                        })

                        const remain = this.out_zone.map((detail) => {
                            return detail.remain
                        })

                        const lose = this.out_zone.map((detail) => {
                            return detail.lose
                        })

                        const use_qty = this.out_zone.map((detail) => {
                            return detail.use_all
                        })

                        const use_price = this.out_zone.map((detail) => {
                            return parseFloat(detail.use_all * detail.mat_price).toFixed(2)
                        })

                        const throw_away_price = this.out_zone.map((detail) => {
                            return parseFloat(detail.mat_price * detail.lose).toFixed(2)
                        })

                        const data = {
                            mat_id: mat_id,
                            lot_detail_id: lot_detail_id,
                            remain: remain,
                            lose: lose,
                            use_qty:use_qty,
                            use_price: use_price,
                            throw_away_price: throw_away_price,
                        }
                        zoneall.summarizeZoneUpdate(data).then((response) => {
                            if (response.data.successful === true) {
                                this.open_alert_show_add = true
                                this.loading_page = false
                            }
                        }).catch((error) => {
                            if (error.response.status === 401) {
                                this.$store.commit('logOutSuccess')
                                this.$router.push('/login')
                            }
                        })
                    }
                }
            }
        },
        async confirmSuccess() {
            this.$router.push('/stockinout')
        },
    },
    computed: {
        amount_all() {
            let check_val = 0
            this.out_zone.forEach((detail) => {
                let val_all = parseFloat(detail.remain) + parseFloat(detail.lose)
                if (val_all > detail.quantity) {
                    check_val += 1
                }
                if (detail.remain === null || detail.lose === null || detail.remain === '' || detail.lose === '') {
                    check_val += 1
                }
            })
            
            return check_val
        },
        text_erroramount_all(){
            let check_val = false
            this.out_zone.forEach((detail) => {
                if (detail.remain === null || detail.lose === null || detail.remain === '' || detail.lose === '') {
                    check_val = true
                }
            })

            return check_val
        }
    },
    mounted() {
        this.zoneDetail()
    }
}
</script>

<style scoped>
.border_header_add_lotout_summarize_list {
    border: thin solid rgba(0, 0, 0, 0.12);
}
</style>
